import React from 'react'
import './title.css'

function About() {
  return (
    <div className='tagline'>
      <div className='main'>Upload your resume, tell us your desired job title, and we’ll blossom it into a polished, tailored masterpiece</div>
      <div className='sub'>Turn your resume into a story they’ll remember 💌</div>
    </div>
  )
}

export default About;
